import React, { useRef } from "react";
import { motion } from "framer-motion";

/**
 * Magnetic wrapper — element subtly follows the cursor while hovered.
 */
export default function Magnetic({ children, strength = 0.4, className = "" }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const relX = e.clientX - (rect.left + rect.width / 2);
    const relY = e.clientY - (rect.top + rect.height / 2);
    el.style.transform = `translate3d(${relX * strength}px, ${relY * strength}px, 0)`;
  };

  const onLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = "translate3d(0,0,0)";
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={className}
      style={{ transition: "transform 0.45s cubic-bezier(0.16,1,0.3,1)", display: "inline-flex" }}
    >
      {children}
    </motion.div>
  );
}
